module.exports = __webpack_public_path__ + "static/media/400072_01.86d1c59e.png";